const meta = {
  'use-events': 'View and create',
  dashboards: 'Dashboards',
  services: 'Services',
  traces: 'Traces',
};

export default meta;
